import { formatDateTime, MOTChangeApprovalStatus } from "helpers";
import PdfGenerator from "pages/pdftemplates/generateModeOfTransportation";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeGetRequest } from "request";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const MOTChangeRequestWorkflow = (props: {role: string}) => {
    const { role } = props
    const params: any = useParams()
    const [modeOfTransportation, setModeOfTransportation] = useState<Record <string, any>>({})
            
    const getModeOfTransportationById = () => {        
        var request = {
            what: "getModeOfTransportationById",
            id: params.id,
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                setModeOfTransportation(res)
            })
            .catch((error) => 
                {console.log(error)}
            );
    }

    const getCurrentApprovalLevel = () => {
        if(modeOfTransportation?.approval?.find((data: { role: any}) => data.role === "EDTechnicalDirectorate")?.approved === "Approved") return 8
        else if(modeOfTransportation?.approval?.find((data: { role: any}) => data.role === "GMTechnicalLogistics")?.approved === "Approved") return 7
        else if(modeOfTransportation?.approval?.find((data: { role: any}) => data.role === "DGMTechnicalLogistics")?.approved === "Approved") return 6
        else if(modeOfTransportation?.approval?.find((data: { role: any}) => data.role === "TransitManager")?.approved === "Approved") return 5
        else if(modeOfTransportation?.requesterGeneralManagerApproval === "Approved") return 4
        else if(modeOfTransportation?.requesterManagerApproval === "Approved") return 3
        else if(modeOfTransportation?.shippingOfficerCheck === "Approved") return 2
        else return 1
    }
    
    useEffect(() => {
        getModeOfTransportationById()

        // eslint-disable-next-line
    }, [])

    return (
        <div className="main-inner mt-1" style={{minHeight: "500px", paddingTop: "16px"}}>
            <div
                className="mb-2"
                style={{
                padding: "12px",
                margin: "0 16px",
                marginBottom: "40px",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                }}
            >
                <Box>
                <Stepper
                    activeStep={modeOfTransportation.finalApprovalStatus !== "Pending" ? getCurrentApprovalLevel() : getCurrentApprovalLevel()}
                    alternativeLabel
                >
                    {MOTChangeApprovalStatus().map(
                    (label: any, index: number) => (
                        <Step key={index}>
                        <StepLabel>
                            {label.value === 1 && (
                                <span className="text-grey">
                                    {formatDateTime(modeOfTransportation?.createdDate )}
                                </span>
                            )}
                            {label.value === 2 && (
                                <span className="text-grey">
                                    {formatDateTime(modeOfTransportation?.shippingOfficerDate )}
                                </span>
                            )}
                            {label.value === 3 && (
                                <span className="text-grey">
                                    {formatDateTime(modeOfTransportation?.requesterManagerDate )}
                                </span>
                            )}
                            {label.value === 4 && (
                                <span className="text-grey">
                                    {modeOfTransportation?.updatedDate && modeOfTransportation?.requesterGeneralManagerApproval === "Approved" ?
                                        formatDateTime(modeOfTransportation?.updatedDate) : "N/A"}
                                </span>
                            )}
                            {label.value > 4 && (
                                <span className="text-grey">
                                    {formatDateTime(modeOfTransportation?.approval
                                        ?.filter((data: { role: any}) => data.role === label.name)
                                        // get the latest approval
                                        .sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime())[0]
                                        ?.createdDate )}
                                </span>
                            )}
                        
                            <br />
                            <span>{label.name}</span>
                            <br />
                            <br />
                            {/* Indicating the approval low ha ended and displaying the final decision */}
                            {(modeOfTransportation.finalApprovalStatus !== "Pending" && label.value === getCurrentApprovalLevel()) && <span className={modeOfTransportation.finalApprovalStatus === "Approved" ? 'uppercase text-green' : 'uppercase text-red'}>Change Request - {modeOfTransportation.finalApprovalStatus}</span>}
                        </StepLabel>
                        </Step>
                    )
                    )}
                </Stepper>
                </Box>
            </div>

            {/* MOT Document */}
            <PdfGenerator role={role} />
        </div>
    )
}

export default MOTChangeRequestWorkflow